import { render, staticRenderFns } from "./SaleMessengerReport.vue?vue&type=template&id=56c13d1d&scoped=true"
import script from "./SaleMessengerReport.vue?vue&type=script&lang=js"
export * from "./SaleMessengerReport.vue?vue&type=script&lang=js"
import style0 from "./SaleMessengerReport.vue?vue&type=style&index=0&id=56c13d1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c13d1d",
  null
  
)

export default component.exports